{
  "info": "Información",
  "negative": "Error",
  "positive": "Éxito"
}
